import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import * as z from 'zod'
import useMutationResetTOTP from '../../api/hooks/useMutationResetTOTP'
import { useQueryClient } from '@tanstack/react-query'
import { AuthQueryKey } from '@/modules/auth/keys'

const resetTOTPSchema = z.object({
	password: z.string().min(6, 'รหัสผ่านต้องมีอย่างน้อย 6 ตัว'),
})

type ResetTOTPDialogProps = {
	open: boolean
	onOpenChange: (open: boolean) => void
	id: string
}

export default function ResetTOTPDialog({
	open,
	onOpenChange,
	id,
}: ResetTOTPDialogProps) {
	const { mutate: resetTOTP, isPending: isResetting } = useMutationResetTOTP(id)
	const queryClient = useQueryClient()

	const form = useForm<z.infer<typeof resetTOTPSchema>>({
		resolver: zodResolver(resetTOTPSchema),
	})

	const onSubmit = (data: z.infer<typeof resetTOTPSchema>) => {
		resetTOTP(data, {
			onSuccess: () => {
				toast.success('รีเซ็ต TOTP สำเร็จ')
				form.reset()
				onOpenChange(false)
				queryClient.invalidateQueries({
					queryKey: [AuthQueryKey.Profile],
				})
			},
			onError: (error) => {
				showErrorToast(error)
			},
		})
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>รีเซ็ต Two-Factor Authentication</DialogTitle>
					<DialogDescription>
						กรุณากรอกรหัสผ่านปัจจุบันเพื่อยืนยันการรีเซ็ต TOTP
					</DialogDescription>
				</DialogHeader>
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
						<FormField
							control={form.control}
							name="password"
							render={({ field }) => (
								<FormItem>
									<FormLabel>รหัสผ่านปัจจุบัน</FormLabel>
									<FormControl>
										<Input
											type="password"
											placeholder="กรอกรหัสผ่านปัจจุบัน..."
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<DialogFooter>
							<Button type="submit" disabled={isResetting}>
								ยืนยันการรีเซ็ต TOTP
							</Button>
						</DialogFooter>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	)
}
